import { Helmet } from 'react-helmet';
import React from 'react';
const Seo = ({ title, description, pathSlug, image }) => {
  const url = `https://malikgabroun.com/${pathSlug}`
  console.log(description)
	return (
<Helmet htmlAttributes={{ lang: 'en' }} title={title} meta={[
        {
          name: 'og:description',
          content: description,
        },
        {
            name: 'og:title',
            content: title
          },
        {
            name: 'og:image',
            content: image
          },
		]}
    />
 );
}
export default Seo;